export const accountKeys = {
  data: (id: string) => ['account:data', id] as const,
};
